import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import LoadingSpinner from '../../../utils/LoadingSpinner';

import { get_workers_stats_peak } from '../../../../actions/workerStatsActions';

const WorkersPeakHours = () => {
	const dispatch = useDispatch();

	const { worker_stats_loading, workers_stats_peak } = useSelector(state => state.workerStats);

	const [days, setDays] = useState(7);

	useEffect(() => {
		dispatch(get_workers_stats_peak(days));
	}, [days]);

	const peakData = workers_stats_peak?.data?.peak_hours || [];
	const busiest = workers_stats_peak?.data?.busiest_hour;
	const quietest = workers_stats_peak?.data?.quietest_hour;

	return (
		<Card className='shadow-sm mb-3 card-border'>
			<Card.Body>
				<Card.Title className='text-center' as='h5'>Peak Hours Analysis</Card.Title>
				<Row className='mb-3 align-items-center'>
					<Col xs={4}>
						<Form.Select value={days} onChange={(e) => setDays(Number(e.target.value))}>
							<option value={3}>Last 3 days</option>
							<option value={7}>Last 7 days</option>
							<option value={14}>Last 14 days</option>
						</Form.Select>
					</Col>
					<Col className='text-end'>
						{busiest && <span className='me-3'><strong>Busiest:</strong> {busiest.hour_label} ({busiest.avg_jobs?.toFixed(1)} avg)</span>}
						{quietest && <span><strong>Quietest:</strong> {quietest.hour_label} ({quietest.avg_jobs?.toFixed(1)} avg)</span>}
					</Col>
				</Row>

				{worker_stats_loading
					? <LoadingSpinner loadingMsg='Loading peak hours' />
					: peakData.length === 0
						? <p className='text-center text-muted'>No peak data available</p>
						: <ResponsiveContainer width='100%' height={300}>
							<BarChart data={peakData} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
								<CartesianGrid strokeDasharray='3 3' />
								<XAxis dataKey='hour_label' fontSize={12} />
								<YAxis />
								<Tooltip formatter={(value) => value.toFixed(1)} />
								<Bar dataKey='avg_jobs' fill='#0d6efd' name='Avg Jobs/Day' />
							</BarChart>
						</ResponsiveContainer>
				}
			</Card.Body>
		</Card>
	);
}

export default WorkersPeakHours;
